import React from "react";
import { PageHero, useSeo } from "../components/Shared";
import { COMPANY } from "../lib/site";

const H = ({ children }) => (
  <h2 className="mt-10 text-lg font-extrabold tracking-tight text-brand-black md:text-lg">{children}</h2>
);
const P = ({ children }) => <p className="mt-3 text-sm leading-relaxed text-brand-gray sm:text-base">{children}</p>;
const LI = ({ children }) => <li className="mt-2 text-sm leading-relaxed text-brand-gray sm:text-base">{children}</li>;

export default function Accessibility() {
  useSeo("Accessibility Statement | MJG Promotions", "MJG Promotions' commitment to digital accessibility and WCAG 2.2 AA conformance on mjgpromotions.com.");
  return (
    <>
      <PageHero eyebrow="Legal" title="Accessibility Statement" intro="Our commitment to a website everyone can use." />
      <section className="bg-white py-16 sm:py-20" data-testid="accessibility-page">
        <div className="mx-auto max-w-3xl px-5">
          <p className="text-sm font-semibold text-brand-gray">Last updated: June 2026</p>
          <P>
            {COMPANY.name} is committed to ensuring that {COMPANY.domain} is accessible to the widest possible
            audience, including people with disabilities. We aim to conform to the Web Content Accessibility
            Guidelines (WCAG) 2.2, Level AA.
          </P>

          <H>Measures We Take</H>
          <ul className="ml-5 list-disc">
            <LI>Semantic HTML structure with proper headings, landmarks, and labels</LI>
            <LI>Sufficient color contrast between text and backgrounds</LI>
            <LI>Full keyboard navigation, visible focus indicators, and a skip-to-content link</LI>
            <LI>Text alternatives for meaningful images</LI>
            <LI>Support for reduced-motion preferences — animations are disabled for users who request it</LI>
            <LI>Responsive layouts that support zoom up to 200% and a range of screen sizes</LI>
          </ul>

          <H>Ongoing Effort</H>
          <P>
            Accessibility is an ongoing effort. We review the website periodically as content and features change and
            work to remedy issues as they are identified. Some third-party content or linked external portals may not
            be fully within our control.
          </P>

          <H>Feedback & Assistance</H>
          <P>
            If you experience difficulty accessing any part of this website, or would like to request information in
            an alternative format, please contact us — we will be glad to help:
          </P>
          <ul className="ml-5 list-disc">
            <LI>Phone: <a href={COMPANY.phoneHref} className="font-semibold text-brand-red hover:underline">{COMPANY.phone}</a></LI>
            <LI>Email: <a href={COMPANY.emailHref} className="font-semibold text-brand-red hover:underline">{COMPANY.email}</a></LI>
            <LI>Mail: {COMPANY.name}, {COMPANY.address}</LI>
          </ul>
          <P>
            When contacting us about an accessibility issue, please include the web address of the page and a
            description of the problem. We aim to respond within a few business days.
          </P>
        </div>
      </section>
    </>
  );
}
